import apiAsync from '../axios'
import { InterFaceUrl_SEC, InterFaceUrl_QUOT, InterFaceUrl_MKTMGR, InterFaceUrl_CRM } from '../config'
import paramsWrap from '../params/params-wrap'
import langUtils from '@/lang/utils'

export default {
  /**
   * 获取风口列表数据
   * params: {
   *  id: 风口ID
   * }
   */
  getList: (data) => apiAsync({
    method: 'post',
    url: InterFaceUrl_QUOT('/tuyere/getList'),
    data: paramsWrap.CONTAIN(data, { lang: langUtils.getLangAlias() }),
    loading: true,
    catchs: true,
    toast: true
  }),
  /**
   * 获取热门股单风口信息
   * params: {
   *  id: 风口ID
   * }
   */
  getTuyereDetail: (data) => apiAsync({
    method: 'post',
    url: InterFaceUrl_QUOT('/tuyere/getDetail'),
    data: paramsWrap.CONTAIN(data, { lang: langUtils.getLangAlias() }),
    loading: true,
    catchs: true,
    toast: true
  }),
  /**
   * 获取我的行情数据
   * params: {
   *  userId: 用户id
   * }
   */
  findPackageInfo: (data) => apiAsync({
    method: 'post',
    url: InterFaceUrl_MKTMGR('/mktmgr_api/find_package_info'),
    data: paramsWrap.OTHER(data),
    loading: true,
    catchs: true,
    toast: true
  }),
  /**
   * 获取客户经理ID
   * @param sessionId
   * @param sessionUserId
  */
  getManagerId: (data) => apiAsync({
    method: 'post',
    url: InterFaceUrl_SEC('/open_api/customer_manager'),
    data: paramsWrap.COMMON(data),
    loading: true,
    catchs: true,
    toast: true
  }),
  /**
   * 获取客户经理信息
   * @param managerId
  */
  getManagerInfo: (data) => apiAsync({
    method: 'post',
    url: InterFaceUrl_CRM('/crm/managerInfoController/queryInfo'),
    data: data,
    loading: true,
    catchs: true,
    toast: true
  }),
  getProtocol: code  => apiAsync({
    method: 'post',
    url: InterFaceUrl_CRM(`/data/getDataTextByCode?code=${code}`),
    loading: true,
    catchs: true,
    toast: true
  })
}